import { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import LandingPage from "@/pages/LandingPage";
import ZenithPage from "@/pages/ZenithPage";
import FaqPage from "@/pages/FaqPage";
import MyBandsPage from "@/pages/MyBandsPage";

/**
 * React Router keeps the window scroll position across navigations, so clicking
 * a CTA at the foot of the landing page would drop you into /app already
 * scrolled down. Reset on every pathname change.
 *
 * Only pathname is watched — hash links (#how, #data) must keep their anchor
 * behaviour rather than being yanked back to the top.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#020204]">
      <div className="noise-overlay" />
      <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* "/" must stay free of API calls — ZenithPage fetches history and
              constellation boundaries on mount, which would wake the
              scale-to-zero backend before anyone has asked for anything. */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/app" element={<ZenithPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/my-bands" element={<MyBandsPage />} />
        </Routes>
      </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;
